import { cva, VariantProps } from 'class-variance-authority';
import { HTMLAttributes } from 'react';

const containerClassNames = cva('tw-container', {
    variants: {
        center: {
            true: 'tw-flex tw-h-page tw-items-center tw-justify-center'
        },
        narrow: {
            true: 'tw-max-w-screen-sm tw-mx-auto'
        }
    }
});

export interface ContainerProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof containerClassNames> {}

export default function Container({ children, className, ...props }: ContainerProps) {
    return (
        <div className={containerClassNames({ className, ...props })} {...props}>
            {children}
        </div>
    );
}
